import type { PermissionName, PermissionStatusMap } from '@heidi/agents/contracts';

export const deriveMissingPermissions = (
  required: readonly PermissionName[],
  statuses: PermissionStatusMap
): PermissionName[] =>
  required.filter((permission) => statuses[permission] !== 'granted');
